import type { Messages } from '../types';

export const children = {
  title: 'Anak saya',
  addChild: 'Tambah anak',
  noChildren: 'Tiada anak ditambah',
  noChildrenBody: 'Hubungkan anak anda untuk mengikuti kemajuan mereka.',
  whatYoullSee: 'Apa yang anda akan lihat',
  sampleTag: 'Contoh',
  sampleNoticeTitle: 'Ini hanya contoh.',
  sampleNoticeBody: 'Hubungkan anak anda untuk melihat kemajuan sebenar mereka.',
  acceptRequest: 'Terima permintaan anak',
  declineRequest: 'Tolak permintaan anak',
  cancelRequest: 'Batalkan permintaan hubungan ibu bapa',
  acceptRequestCta: 'Terima permintaan',
  declineRequestCta: 'Tolak',
  cancelRequestCta: 'Batalkan permintaan',
  linkRequestPending: 'Permintaan hubungan menunggu kelulusan anda',
  waitingForChild: 'Menunggu {childName} menerima permintaan ibu bapa dalam apl pelajar',
  yourChild: 'anak anda',
  showCode: 'Tunjuk kod',
  cancelRequestTitle: 'Batalkan permintaan ini?',
  cancelRequestBody: 'Permintaan hubungan untuk {childName} akan dibatalkan.',
  cancelRequestConfirm: 'Ya, batalkan',
  thisChild: 'anak ini',

  mathWithLevel: 'Matematik {level}',
  math: 'Matematik',
  chaptersCompleted: '{done} daripada {total} bab selesai',
  noDataYet: 'Tiada data lagi',
  dailyAverage: 'Purata harian',
  accuracy: 'Ketepatan',
  minsShort: '{mins} min',

  statusCompleted: 'Selesai',
  statusStarted: 'Sedang dibuat',
  statusPending: 'Belum dimulakan',
  metaAssigned: 'Diberi {date}',
  metaStarted: 'Dimulakan {date}',
  metaDone: 'Siap {date}',
  metaCorrect: '{correct}/{total} betul',

  linkYourChild: 'Hubungkan anak anda',
  linkYourChildBody:
    'Minta anak anda buka Tupai, pergi ke Profil dan masukkan kod ini di bawah "Ada kod daripada ibu bapa?"',
  linkYourChildAlt: 'Atau minta anak anda hantar pautan mereka kepada anda.',
  yourCode: 'Kod anda',
  couldNotLoadCode: 'Tidak dapat memuatkan kod anda.',
  retry: 'Cuba lagi',
  expiresIn: 'Tamat dalam {timeLeft}',
  expired: 'Tamat tempoh',
  copied: 'Disalin',
  copy: 'Salin',
  newCode: 'Kod baharu',
  consentTitle:
    'Beri persetujuan dan hubungkan {hasName, select, true {{childName}} other {anak anda}}',
  consentIntro:
    'Tupai memerlukan persetujuan ibu bapa untuk menghubungkan mana-mana pelajar. Setelah berhubung, anda boleh melihat kemajuan pembelajaran {hasName, select, true {{childName}} other {anak anda}}. {hasName, select, true {{childName}} other {Anak anda}} akan dimaklumkan apabila anda berhubung.',
  consentCollectsTitle: 'Apa yang Tupai kumpul daripada anak anda',
  consentCollectsIntro:
    'Tupai ialah apl pembelajaran matematik. Untuk menyediakannya, kami mengumpul dan menggunakan perkara berikut tentang anak anda:',
  consentCollectsList:
    'Nombor telefon (untuk log masuk) · Nama dan umur · Nama sekolah · Aktiviti dan kemajuan pembelajaran',
  consentCollectsUse:
    'Ini digunakan hanya untuk menjalankan perkhidmatan pembelajaran. Tupai tiada iklan dan tidak akan menjual maklumat anak anda.',
  consentPrivacyLead: 'Lihat',
  consentPrivacyLink: 'Dasar Privasi',
  consentSeeTitle: 'Apa yang anda akan lihat',
  consentSeeBody:
    'Aktiviti, laporan dan ketepatan {hasName, select, true {{childName}} other {anak anda}}. Bukan mesej atau kenalan mereka.',
  consentCheckbox:
    'Saya ialah ibu bapa atau penjaga sah {hasName, select, true {{childName}} other {anak saya}}, dan saya bersetuju Tupai mengumpul dan menggunakan maklumat mereka seperti yang diterangkan di atas.',
  consentNameLabel: 'Nama anak anda',
  consentNamePlaceholder: 'Nama panggilan atau nama sebenar',
  consentNameHint: 'Anak anda melihat nama ini dalam Tupai.',
  consentNameError: 'Masukkan nama anak anda.',
  consentNameTooLong: 'Gunakan tidak lebih 100 aksara.',
  consentAgree: 'Beri persetujuan dan hubungkan',
  consentCancel: 'Bukan sekarang',
  approveBlockedSeatBody:
    'Pelan anda tiada tempat kosong untuk {hasName, select, true {{childName}} other {anak anda}}. Tukar pelan anda dahulu, kemudian terima permintaan ini.',
  approveBlockedSyllabusBody:
    'Sukatan pelajaran {hasName, select, true {{childName}} other {anak anda}} memerlukan pelan yang lebih tinggi. Tukar pelan anda dahulu, kemudian terima permintaan ini.',
  approveBlockedWaiting:
    'Permintaan {hasName, select, true {{childName}} other {anak anda}} kekal di sini sehingga anda menerima atau menolaknya.',
  errStudentAlreadyLinked:
    'Anak ini sudah berhubung dengan seorang ibu bapa. Seorang anak hanya boleh mempunyai satu ibu bapa yang berhubung pada satu masa — mereka perlu memutuskan hubungan itu dahulu, kemudian kongsi kod baharu dengan anda.',

  planOfferTitle: 'Naik taraf untuk laporan AI dan kerja rumah',
  planOfferBody: 'Cuba Family Solo percuma selama {days} hari. Batal bila-bila masa.',
  planOfferCta: 'Mulakan percubaan percuma',
  planOfferEndedTitle: 'Percubaan percuma anda telah tamat',
  planOfferEndedBody: 'Pilih pelan untuk mendapatkan semula laporan AI dan kerja rumah.',
  planOfferEndedCta: 'Pilih pelan',
  coveredByPlan: 'Diliputi pelan anda',
  seatCheckOffline: 'Tiada sambungan. Semak internet anda dan cuba lagi.',
  notCoveredByPlan: 'Tidak diliputi pelan',
  overPlanLimit: 'Melebihi had pelan',

  unlinkTitle: 'Putuskan hubungan dengan {childName}?',
  unlinkBody: 'Anda tidak lagi melihat kemajuan {childName}. Inilah yang akan berlaku:',
  unlinkKeepsAccount: '{childName} mengekalkan akaun pelajar dan semua kemajuan mereka.',
  unlinkKeepsHistory:
    'Laporan dan sejarah kerja rumah anda dikekalkan, sekiranya anda berhubung semula.',
  unlinkNeedsNewCode: 'Untuk berhubung semula nanti, anda perlukan kod baharu dari apl mereka.',
  unlinkConfirm: 'Putuskan hubungan dengan {childName}',
  keepLinked: 'Kekalkan hubungan',

  railChildrenCount:
    '{pending, plural, =0 {{linked} dipautkan} other {{linked} dipautkan · {pending} menunggu}}',
} as const satisfies Messages['children'];
